export default __webpack_public_path__ + "static/media/GHX_logo.aa484a5e.svg";